import { atom } from 'jotai';
import { tabStore } from './tabStore';

/*
 * Who is signed in, as signup knows it: read from the access token (email,
 * name, how they signed in when Keycloak says), plus the organization once
 * iam has named one. Drives the account chip and "Continue as".
 */

export interface Who {
    sub?: string;
    email?: string;
    name?: string;
    /** "google" when the token says so (Keycloak's identity_provider claim). */
    provider?: string;
}

export function whoFromToken(token?: string): Who | undefined {
    try {
        const part = token?.split('.')[1];
        if (!part) return undefined;
        const c = JSON.parse(decodeURIComponent(escape(atob(part.replace(/-/g, '+').replace(/_/g, '/')))));
        const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);
        return { sub: str(c.sub), email: str(c.email), name: str(c.name), provider: str(c.identity_provider) };
    } catch {
        return undefined;
    }
}

export interface SignedIn {
    who: Who;
    /** How their organization reads, once known. */
    org?: string;
}

/** The signed-in person on this page, or null when none is known. */
export const signedInAtom = atom<SignedIn | null>(null);

const CONFIRMED = 'dodil_continue_as';

/** They said "Continue" as this person, in this flow (the tab). */
export function confirmedAs(who: Who): boolean {
    return !!who.sub && tabStore.get(CONFIRMED) === who.sub;
}

export function confirmAs(who: Who): void {
    if (who.sub) tabStore.set(CONFIRMED, who.sub);
}
